import Vue from 'vue'
import DialogForm from './index.vue'

const DialogFormConstructor = Vue.extend(DialogForm)

const dialogForm = function (options = {}) {
  const instance = new DialogFormConstructor({
    data: options,
  })
  instance.$mount()
  document.body.appendChild(instance.$el)
  instance.visible = true

  return new Promise((resolve, reject) => {
    instance.callback = (action) => {
      if (action === 'confirm') {
        resolve(instance.formData)
      } else {
        reject(action)
      }
    }
  })
}

export default dialogForm
